import cx from 'classnames';

import i18n from 'i18n/config';
import MuiCheckBox from 'UIKit/MuiCheckBox';

import styles from './IndiaOrGlobalModal.module.scss';

const rememberMyChoiceLabel = i18n.t('common:rememberMyChoice');

const RememberMyChoice = ({
  checked = false,
  checkboxClassName,
  handleCheck = () => {},
}: {
  checked: boolean;
  handleCheck: () => void;
  checkboxClassName?: string;
}) => {
  return (
    <div
      className={cx('flex-set flex--align-items-center', styles.rememberMyChoice)}
      data-testid="rememberMyChoice"
    >
      <MuiCheckBox
        name="rememberMyChoice"
        checked={checked}
        onChange={handleCheck}
        data-testid="rememberMyChoiceCheckbox"
        checkedClassName={checkboxClassName}
      />
      <span>{rememberMyChoiceLabel}</span>
    </div>
  );
};

export default RememberMyChoice;
